import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Components from '_components';
export function DataListPresenter(props) {
    function renderItem(item) {
        const id = props.getId(item);
        return (_jsxs("li", { children: [_jsx(Components.Link, { to: '/Blog/entry/' + props.getId(item), children: _jsx(Components.MLT, { text: props.getVisibleName(item) }) }), _jsx("small", { children: props.getDetails(item) })] }, id));
    }
    return _jsx("ul", { children: props.items.map(item => renderItem(item)) });
}
